import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('checked-fill-icon', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 5.5c5.109 0 9.734 2.07 13.081 5.419A18.442 18.442 0 0 1 42.5 24c0 5.109-2.07 9.734-5.419 13.081A18.442 18.442 0 0 1 24 42.5c-5.109 0-9.734-2.07-13.081-5.419A18.442 18.442 0 0 1 5.5 24c0-5.109 2.07-9.734 5.419-13.081A18.442 18.442 0 0 1 24 5.5z",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 13c5.965 0 10.8 4.835 10.8 10.8 0 5.965-4.835 10.8-10.8 10.8-5.965 0-10.8-4.835-10.8-10.8C13 17.835 17.835 13 23.8 13z",
    fill: props.colors[0]
  })));
});